import script from "./SecButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SecButton.vue?vue&type=script&setup=true&lang=js"

import "./SecButton.vue?vue&type=style&index=0&id=b7b0066e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b0066e"]])

export default __exports__